import { ConfirmDialog } from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';

interface DeleteEnvelopeDialogProps {
    isOpen: boolean;
    /** Deleting the only envelope of the cycle empties it, so the message warns before confirming. */
    isLastEnvelope: boolean;
    isDeleting: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

/** Confirmation before an envelope — and every increase entered in it — is deleted. */
export const DeleteEnvelopeDialog = ({
    isOpen,
    isLastEnvelope,
    isDeleting,
    onConfirm,
    onCancel,
}: DeleteEnvelopeDialogProps) => {
    const { t } = useAmelioTranslations();

    const message = isLastEnvelope
        ? `${t('compensation.delete.message')} ${t('compensation.delete.lastEnvelopeWarning')}`
        : t('compensation.delete.message');

    return (
        <ConfirmDialog
            isOpen={isOpen}
            title={t('compensation.delete.title')}
            message={message}
            confirmLabel={t('compensation.delete.confirm')}
            cancelLabel={t('compensation.delete.cancel')}
            onConfirm={onConfirm}
            onCancel={onCancel}
            isLoading={isDeleting}
            // Deleting an envelope takes every increase entered in it with it, and nothing puts it
            // back: the confirm button says so in the error colour rather than the primary one.
            isDestructive
            dataTestId={'compensation-delete-dialog'}
        />
    );
};
